export const missingFieldsDescriptions = {
  nameSurname: "Ime i prezime",
  vocation: "Zanimanje",
  department: "Odjel",
  email: "Email",
  departmentId: "Zavod",
  projectTitle: "Naslov projekta",
  projectAcronym: "Akronim projekta",
  applicationDeadline: "Rok prijave",
  projectSummary: "Sažetak projekta",
  applicationURL: "Link prijave",
  projectApplicant: "Podnositelj prijave",
  projectPartners: "Partneri na projektu",
  totalValue: "Ukupna vrijednost projekta",
  fesbValuePart: "FESB-ov udio vrijednosti projekta",
  projectTeam: "Projektni tim",
  mobilePhoneNumber: "Broj mobitela",
  workTimeThisPercentage: "Postotak radnog vremena na ovom projektu",
  workTimeOtherPercentage: "Postotak radnog vremena na drugim projektima",
  teamLeaderNote: "Napomena voditelja tima",
  sourceOfFunding: "Izvor financiranja",
  projectType: "Vrsta projekta",
  expectedProjectBeginning: "Očekivani početak projekta",
  expectedProjectDurationInMonths: "Očekivano trajanje projekta u mjesecima",
  economicSubjectInvolvement: "Uključenost gospodarskog subjekta",
  currentPersonnelExpense: "Trenutni troškovi zaposlenika",
  newPersonnelExpense: "Novi troškovi zaposlenika",
  equipmentDescriptionAndExpense: "Opis i trošak opreme",
  equipmentAmortizationExpense: "Trošak amortizacije opreme",
  otherServicesExpense: "Trošak drugih usluga",
  materialExpense: "Trošak materijala",
  travelRegistrationEducationExpense:
    "Trošak putovanja, edukacije i registracije",
  expenseNote: "Napomena o trošku",
  partnerExpense: "Trošak partnera",
  downPayment: "Predujam",
  personalFinancingExpense: "Trošak osobnog financiranja",
  newEmploymentBoolean: "Nova radna mjesta",
  consultantServices: "Konzultantske usluge",
  consultantExpense: "Trošak konzultanta",
  consultantExpenseSource: "Izvor srestava za trošak konzultanta",
  requiredDocumentationFESB: "Potrebna dokumentacija FESB-a",
};
